import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./lib/font-awesome/css/all.min.css";
import "@rainbow-me/rainbowkit/styles.css";

import React, { useEffect } from "react";
import toast from "react-hot-toast";
import ToasterCard from "./plugins/Toaster";
import AppRoute from "./plugins/router";

import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./configs/queryClient";

import { WagmiProvider, createConfig, http } from "wagmi";
import { bsc } from "wagmi/chains";
import {
  RainbowKitProvider,
  darkTheme,
  connectorsForWallets,
} from "@rainbow-me/rainbowkit";
import {
  trustWallet,
  coinbaseWallet,
  metaMaskWallet,
  walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";

const projectId = "948bc15a7b5888e5beae17fde670f26a";

// Create a custom BSC Mainnet chain with public RPC endpoints
const customBscMainnet = {
  ...bsc,
  id: 56,
  name: "Binance Smart Chain",
  network: "bsc",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB",
  },
  rpcUrls: {
    default: {
      http: ["https://bsc-dataseed.binance.org/"],
    },
    public: { http: ["https://bsc-dataseed.binance.org/"] },
  },
  blockExplorers: {
    default: { name: "BscScan", url: "https://bscscan.com" },
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 15921452,
    },
  },
};

const connectors = connectorsForWallets(
  [
    {
      groupName: "Recommended",
      wallets: [
        () => metaMaskWallet({ projectId }),
        // () => trustWallet({ projectId }),
        // () => coinbaseWallet({ projectId }),
        // () => walletConnectWallet({ projectId }),

        /* 
        ⚠️ NOTE: If you get "Internal error" for WalletConnect:
        1. Go to: https://cloud.walletconnect.com
        2. Create free account
        3. Get new Project ID
        4. Replace projectId on line 27 above
        
        Temporarily disable wallets by commenting them like this:
        // () => trustWallet({ projectId }),
        // () => coinbaseWallet({ projectId }),
        // () => walletConnectWallet({ projectId }),
        */
      ],
    },
  ],
  {
    projectId,
    appName: "trinity",
  }
);

const config = createConfig({
  autoConnect: true,
  chains: [customBscMainnet],
  connectors,
  transports: {
    [customBscMainnet.id]: http(customBscMainnet.rpcUrls.default.http[0]),
  },
});

function getWalletErrorMessage(reason) {
  if (!reason || typeof reason !== "object") return null;
  const msg =
    reason.message ||
    reason.shortMessage ||
    reason?.info?.error?.message ||
    reason?.data?.message;
  if (msg && typeof msg === "string") return msg;
  if (reason.code === 4001) return "Request rejected";
  if (reason.code === 4100) return "Unauthorized";
  return null;
}

function App() {
  useEffect(() => {
    const handler = (event) => {
      const msg = getWalletErrorMessage(event.reason);
      if (msg) {
        event.preventDefault();
        toast.error(msg);
      }
    };
    window.addEventListener("unhandledrejection", handler);
    return () => window.removeEventListener("unhandledrejection", handler);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <WagmiProvider config={config}>
        <RainbowKitProvider
          theme={darkTheme({
            accentColor: "#f8780c",
            accentColorForeground: "white",
            borderRadius: "large",
            fontStack: "system",
            overlayBlur: "small",
            modalBackground: "#f00",
          })}
          coolMode
          chains={[customBscMainnet]}
        >
          <ToasterCard />
          <AppRoute />
        </RainbowKitProvider>
      </WagmiProvider>
    </QueryClientProvider>
  );
}

export default App;
